<template>
  <div class="isexam">
    <div class="title">
      <span>考试</span>
      <button @click="$emit('gocourse',catId)">返回课程主页</button>
    </div>
    <div class="content">
      <h2>考试说明：</h2>
      <div class="info">
        {{testInfo}}
      </div>
      <template v-if="examType==0">
          <button
              v-if="isFinished"
              class="exambtn"
              @click="$emit('seetheoryexam',paperId,catId,menuId,chapterId)"
            >
            查看理论成绩
          </button>
          <button
            v-else
            class="exambtn"
            @click="$emit('totheoryexam',paperId,catId,menuId,chapterId)"
          >
            进入理论考试
          </button>
      </template>
      <template v-else-if="examType==1">
          <button
            class="toprexam"
            @click="$emit('toprexam',paperId,catId,menuId)"
          >
            进入实操考试
          </button>
      </template>
      <template v-else>
           <button
              v-if="isFinished"
              class="exambtn"
              @click="$emit('seetheoryexam',paperId,catId,menuId,chapterId)"
            >
            查看理论成绩
          </button>
          <button
            v-else
            class="exambtn"
            @click="$emit('totheoryexam',paperId,catId,menuId,chapterId)"
          >
            进入理论考试
          </button>
          <button
            class="toprexam"
            @click="$emit('toprexam',paperId,catId,menuId)"
          >
            进入实操考试
          </button>
      </template>

    </div>
  </div>
</template>

<script>
export default {
  name: "isexam",
  props: {
    title: [String, Number],
    testInfo: String,
    paperId: [String, Number],
    catId: [String, Number],
    menuId: [String, Number],
    isFinished: Boolean,
    chapterId:[String,Number], 
    examType: [String,Number],
    operationQuestionFinished: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
.isexam {
  .title {
    height: 65px;
    border-bottom: 1px solid #eee;
    margin-left: 38px;
    margin-right: 39px;
    display: flex;
    position: relative;

    span {
      color: #333333;
      font-size: 18px;
      padding-top: 30px;
    }

    button {
      border: 0;
      outline: none;
      width: 99px;
      height: 30px;
      background-color: #ffffff;
      border: solid 1px #cecece;
      color: #ef9545;
      font-size: 14px;
      position: absolute;
      right: 17px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .content {
    margin: 0 auto;
    margin-top: 24px;
    margin-left: 33px;
    margin-right: 120px;
    margin-bottom: 50px;
    overflow: hidden;
    min-height: 700px;

    h2 {
      color: #333;
      font-size: 16px;
      margin-bottom: 25px;
      font-weight: bold;
    }

    .info {
      color: #666;
      font-size: 14px;
      margin-bottom: 47px;
    }

    .exambtn {
      width: 148px;
      height: 46px;
      background-color: #f0cd48;
      color: #333;
      font-size: 16px;
      border: 0;
      // border-radius: 3px;
      background-color: #f0cd48;
      margin-right: 33px;
      outline: none;
    }

    .toprexam {
      width: 148px;
      height: 46px;
      background-color: #f0cd48;
      color: #333;
      font-size: 16px;
      border: 0;
      // border-radius: 3px;
      background-color: #2cc299;
      outline: none;
    }
  }
}
</style>
